// El QR del pedido contiene "pedido/<jwt>" y los lectores lo escriben como un teclado.
// Con el lector configurado en inglés y el sistema en español, "/" llega como "-",
// "-" como "'" y "_" como "?". Un JWT solo usa letras, dígitos, "-", "_" y ".", así que
// esos reemplazos no alteran un token leído con la distribución correcta.

/** Indica si la tecla aporta un carácter al código (descarta Shift, Control, etc.). */
export const esTeclaDeCodigo = (key) => typeof key === "string" && key.length === 1;

/** Token del QR a partir del texto escaneado. */
export const leerTokenQrPedido = (texto) =>
  String(texto || "")
    .trim()
    .replace(/^pedido./i, "")
    .replace(/'/g, "-")
    .replace(/\?/g, "_");

/** Recupera la causa del rechazo incluso si GraphQL responde con HTTP 500. */
export const obtenerErrorQrPedido = (resultado) => {
  const error = resultado?.error || resultado;
  const errores = [
    ...(resultado?.errors || []),
    ...(error?.graphQLErrors || []),
    ...(error?.networkError?.result?.errors || []),
  ];
  const esReservaVencida = (item) =>
    (item?.extensions?.code || item?.code) === "RESERVA_VENCIDA" ||
    /^La reserva venció(?:\s|$)/i.test(item?.message || "");
  const causa = errores.find(esReservaVencida) || errores[0] || error;
  const reservaVencida = esReservaVencida(causa);

  return {
    reservaVencida,
    mensaje: reservaVencida
      ? causa.message || "La reserva ya venció"
      : errores[0]?.message || "No se pudo generar el QR. Intentá nuevamente en unos momentos.",
  };
};
